import type { ApiCountryCode } from '../../../api/types';

// For now the sign-in page starts on Iran and its country list is not offered, without waiting for the server's
// guess of the country or its list. A code typed into the number field still picks another country, or none.
export const IS_SIGN_IN_COUNTRY_FIXED = true;

export const JARYAN_SIGN_IN_COUNTRY: ApiCountryCode = {
  iso2: 'IR',
  defaultName: 'Iran',
  countryCode: '98',
  patterns: ['XXX XXX XXXX'],
};

const PERSIAN_NAME = 'ایران';

export function getInitialSignInCountry(): ApiCountryCode | undefined {
  return IS_SIGN_IN_COUNTRY_FIXED ? JARYAN_SIGN_IN_COUNTRY : undefined;
}

// Upstream's rule: the country follows the code typed into the number field, and a code the list cannot place
// clears it, so that any number can be entered. While the country is fixed, Iran is also kept for a number the
// list cannot place yet when it starts with Iran's code, as it does before the list has loaded
export function selectSignInCountry(
  current: ApiCountryCode | undefined,
  suggested: ApiCountryCode | undefined,
  fullNumber: string,
) {
  if (!current) return suggested;
  if (suggested) return suggested.iso2 === current.iso2 ? current : suggested;
  if (!fullNumber.length) return current;

  const digits = fullNumber.replace(/\D/g, '');
  const isIranNumber = IS_SIGN_IN_COUNTRY_FIXED && current.iso2 === JARYAN_SIGN_IN_COUNTRY.iso2
    && digits.startsWith(JARYAN_SIGN_IN_COUNTRY.countryCode);

  return isIranNumber ? current : undefined;
}

// The number field shows the country's code, "+98 ", ahead of what is typed. A number typed or pasted after it
// with its own "+", such as "+98 912…" or "+42…", is read on its own; otherwise its code would be counted twice and
// "+98 912" would become "+98 98 912". A number without a "+" is still read as the national part
export function getTypedFullNumber(value: string, country: ApiCountryCode | undefined) {
  if (!country) return value;

  const prefix = `+${country.countryCode}`;
  if (!value.startsWith(prefix)) return value;

  const rest = value.slice(prefix.length).trimStart();
  return rest.startsWith('+') ? rest : value;
}

// The country list's names may come in English, so Iran is named in the page's language here
export function getSignInCountryName(country: ApiCountryCode | undefined, langCode: string | undefined) {
  if (!country) return '';
  if (country.iso2 === JARYAN_SIGN_IN_COUNTRY.iso2 && langCode?.toLowerCase().startsWith('fa')) return PERSIAN_NAME;

  return country.name || country.defaultName;
}
